import { Form } from 'factorial-form'

import asyncAction from 'modules/core/lib/asyncAction'

import type { Action } from 'modules/automations/store/models/Action'

import type { Storeable } from './Storeable'

export class TimeAction implements Storeable {
  #action: Action
  form: Form

  constructor(action: Action) {
    this.#action = action
    this.form = this._updateForm()
  }

  dispose() {}

  // This is not reactive ATM since it changes the schema. `factorial-form`
  // does not have a way to update the schema and UI-wise it does not
  // make much sense
  _updateForm() {
    return new Form(
      {
        subject: this.#action.metadata.subject,
        subject_attr: this.#action.metadata.subject_attr,
        time_unit: this.#action.metadata.time_unit,
        amount_time: this.#action.metadata.amount_time,
      },
      {
        subject: 'string',
        subject_attr: 'string',
        time_unit: 'string',
        amount_time: 'number',
      }
    )
  }

  async save() {
    if (!this.form.isDirty) return

    const { success } = await asyncAction(() =>
      this.#action.save({
        metadata: this.form.data(),
      })
    )

    if (success) this.form.cleanAll()
  }
}
